module.exports = __webpack_public_path__ + "static/media/Blender-1.98beae1c.webp";